export const FrontendVersion = "v3.2.4";
export const FrontendVersionSHA = "800dc93";
